import SpeciesActions from './Actions'

export const getColumns = (rowId, setRowId, onRequestDelete) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', align: 'center', width: 70 },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 2,
    minWidth: 150,
    editable: true,
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Habilitado',
    type: 'boolean',
    flex: 2,
    minWidth: 150,
    editable: true,
  },
  {
    field: 'estado_validacion',
    headerName: 'Estado verificado',
    headerAlign: 'center',
    align: 'center',
    type: 'singleSelect',
    editable: true,
    valueOptions: [
      { value: 'pendiente', label: 'Pendiente' },
      { value: 'verificado', label: 'Verificado' },
    ],
    flex: 2,
    minWidth: 170,
    valueFormatter: params => {
      if (params?.value === 'verificado') return 'Verificado'
      if (params?.value === 'pendiente') return 'Pendiente'
      return 'No definido'
    },
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => <SpeciesActions {...{ params, rowId, setRowId, onRequestDelete }} />,
    minWidth: 100,
    flex: 1.2,
  },
]
